module.exports = __webpack_public_path__ + "ss.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ss.svg
// module id = 1072
// module chunks = 0